import { render } from "./FeynmanView.vue?vue&type=template&id=2471357b&scoped=true"
import script from "./FeynmanView.vue?vue&type=script&lang=js"
export * from "./FeynmanView.vue?vue&type=script&lang=js"

import "./FeynmanView.vue?vue&type=style&index=0&id=2471357b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2471357b"]])

export default __exports__